import { useParams } from "react-router";
import { useVbsOfferShowQuery } from "@/services/backend/vbs/offers/api/offer-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CalculationComponent } from "@/routes/processes/[processId]/vbs/calculations/[calculationId]/calculation/calculation-route";

export function OfferCalculationRoute() {
  const { offerId } = useParams();
  const {
    data: offer,
    isLoading,
    error,
  } = useVbsOfferShowQuery({ id: offerId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <CalculationComponent
      calculationId={offer!.calculationId}
      disabled={offer!.immutable}
    />
  );
}
